// @flow
import styled, { keyframes } from 'styled-components';

/* stylelint-disable */
/* eslint-disable */

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: scale(0.95) translateY(10px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
`;

export const ModalOverlay: any = styled.div`
  position: fixed;
  z-index: 1000001;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

export const Card: any = styled.div`
  max-width: 460px;
  width: 100%;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 28px 64px rgba(0, 0, 0, 0.45);
  background: #fff;
  animation: ${fadeIn} 0.22s ease-out;
`;

export const CardHeader: any = styled.div`
  background: ${({ theme }) => theme.plus?.gradientPremium || 'linear-gradient(135deg, #1f4891 0%, #2ab6b9 100%)'};
  padding: 32px 30px 28px;
  text-align: center;
  position: relative;
`;

export const SavingsBadge: any = styled.div`
  position: absolute;
  top: 16px;
  right: 16px;
  background: #ffd700;
  color: #1a1a2e;
  font-weight: 800;
  font-size: 11px;
  padding: 4px 10px;
  border-radius: 20px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
`;

export const LogoWrapper: any = styled.div`
  margin-bottom: 12px;
`;

export const CardTitle: any = styled.h3`
  color: #fff;
  font-size: 22px;
  font-weight: 700;
  margin: 0;
  line-height: 1.3;
`;

export const CardBody: any = styled.div`
  padding: 28px 30px 30px;
  text-align: center;
`;

export const Description: any = styled.p`
  color: #444;
  font-size: 15px;
  line-height: 1.6;
  margin-bottom: 8px;
`;

export const PriceRow: any = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: #f0fafa;
  border: 1px solid #b2e8ea;
  border-radius: 10px;
  padding: 10px 18px;
  margin: 16px 0 24px;
`;

export const PriceOriginal: any = styled.span`
  color: #999;
  text-decoration: line-through;
  font-size: 16px;
`;

export const PriceCurrent: any = styled.span`
  color: #1f4891;
  font-weight: 800;
  font-size: 22px;
`;

export const Actions: any = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const PrimaryLink: any = styled.button`
  display: block;
  width: 100%;
  background: ${({ theme }) => theme.plus?.gradientPremium || 'linear-gradient(135deg, #1f4891 0%, #2ab6b9 100%)'};
  color: #fff;
  font-weight: 700;
  font-size: 16px;
  padding: 15px 20px;
  border-radius: 10px;
  border: none;
  text-align: center;
  cursor: pointer;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.88;
    color: #fff;
  }
`;

export const SecondaryLink: any = styled.button`
  display: block;
  width: 100%;
  background: transparent;
  border: none;
  color: #888;
  font-size: 14px;
  padding: 10px 20px;
  text-align: center;
  cursor: pointer;
  transition: color 0.15s ease;

  &:hover {
    color: #444;
  }
`;

/* stylelint-enable */
/* eslint-enable */
